import { useParams } from 'react-router';
import React from 'react';
import { hasPermissionForFuncInProject } from 'src/utils/controllerHasPermissionsAdapter';
import { ts } from 'src/utils/translate';
import { IS_READ_ONLY_USER } from "src/utils/controllerAdapterForOfferPage";
import { Button } from "@mui/material";

export const CustomRowButton = (props: any) => {
  const {
    table,
    customRowButtonPressed,
    setCustomRowButtonPressed,
    setCurrentRowInEditing,
  } = props;

  const params = useParams<{ projectId: string }>();

  const tableName = React.useMemo(() => {
    if(table.isJustUnassignedFloor !== undefined && table.isJustUnassignedFloor === true){
      return table.floorName;
    } else if (table.floorName && table.roomName) {
      return `${table.floorName} - ${table.roomName}`;
    } else if (table.name) {
      return table.name;
    }
  }, [table]);

  return hasPermissionForFuncInProject(
    "quote_sect.add_custom_product",
    params.projectId
  ) && !IS_READ_ONLY_USER ? (
    <React.Fragment>
      <Button
        className="add-row-btn btn blue-uplan lightershadow remove-on-export"
        sx={{
            padding: "5px",
            paddingX: "15px",
            backgroundColor: "hsl(218, 89%, 63%)",
            color: "white",
            borderRadius: "6px",
            textTransform: "none",
            fontSize: "14px",
            cursor: "pointer",
            '&:hover': {
                backgroundColor: "hsl(218, 89%, 59%)",
            },
            marginTop: "30px"
        }}
        onClick={() => {
          if (!customRowButtonPressed) {
            setCustomRowButtonPressed(true);
          }
          setCurrentRowInEditing({
            entityId: table.id,
            entityType: table.entitytype,
          });
        }}
      >
        {ts("add_custom_to", "addCustomTo")}
        <span style={{ marginLeft: "4px" }}>{` ${tableName}`}</span>
      </Button>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <button className="add-row-btn btn blue-uplan disable remove-on-export">
        {ts("add_custom_to", "addCustomTo")}
        <span>{` ${tableName}`}</span>
      </button>
    </React.Fragment>
  );
};
